import { Box, BoxProps } from 'grommet'

type Props = BoxProps

export const Divider = (props: Props) => {
  return <Box background="#CBD5E0" width="1px" height="1px" fill="horizontal" {...props} />
}
